import type { FC } from 'react'

import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const MyObjectCardSkeleton: FC = () => (
  <Paper
    padding={[12]}
    radius="16px"
    className={s.card}
  >
    <div className={s.content}>
      <div className={s.statusRow}>
        <Skeleton
          width={86}
          height={24}
          borderRadius={6}
        />

        <Skeleton
          width={92}
          height={24}
          borderRadius={6}
        />
      </div>

      <div className={s.objectInfo}>
        <Skeleton
          width="68%"
          height={18}
          borderRadius={4}
        />

        <Skeleton
          width="84%"
          height={16}
          borderRadius={4}
        />
      </div>
    </div>
  </Paper>
)
